import { DatePicker, Layout, Tooltip } from "antd";
import FormItem from "antd/lib/form/FormItem";
import React, { createContext, useContext } from "react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import { QuaiboDailyProductionForm } from "./QuaiboDailyProductionForm";

import QuaiboDailyProductionStore from "../store/quaibodailyproductionstore";

import { observer } from "mobx-react-lite";
import { getPickerDate, toAntPickerDate } from "../../../Utility/modules/datePicker";
import { CommandBar } from "@fluentui/react";
import { X } from "react-feather";
const { Content } = Layout;
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
const initData = {
  blpd: 0,
  bsw: 0,
  condensate: 0,
  crudeInjectionGGF: 0,
  cumCondProduction: 0,
  cumGasProduction: 0,
  cumGrossProduction: 0,
  cumNetProduction: 0,
  cumWaterProduction: 0,
  drainedWater: 0,
  flareGas: 0,
  fuelGas: 0,
  gas: 0,
  oil: 0,
  operatingHrs: 0,
  ownUseGas: 0,
  productionDate: new Date(),
  quaiboDailyProductionId: 0,
  remarks: "",
  stationAPI: 0,
  uploadedBy: null,
  uploadedOn: null,
  water: 0,
};
export const QuaiboManualFormEntry = observer(() => {
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);
  return (
    <Layout
      style={{
        background: "#fff",
        marginTop: "20px",
      }}
    >
      <Content
        className="ms-depth8"
        style={{
          background: "#F0F2F5",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            {" "}
            <SubPageHeaderTitle title="Quaibo Daily Field Production Entry  Pane" />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <CommandBar
              items={[
                {
                  key: "clear",
                  text: "Clear Entries",
                  onRenderIcon: () => <X />,
                  onClick: async () => {
                    quaiboDailyProductionStore.initFormaData = initData;
                    quaiboDailyProductionStore.uploadDate = new Date();
                    quaiboDailyProductionStore.wellparameters.clear();
                    await quaiboDailyProductionStore.loadInitialWellParameters();
                    quaiboDailyProductionStore.showNaocDailyProductionDialog = true;
                  },
                },
              ]}
            />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <FormItem
              label={
                <span style={{ color: "red" }}>Production Refer Date *</span>
              }
            >
              <Tooltip title="Quaibo field production date">
                <DatePicker
                  value={toAntPickerDate(quaiboDailyProductionStore?.uploadDate)}
                  onChange={(date, dateString) => {
                    console.log(date, dateString);
                    quaiboDailyProductionStore.uploadDate = dateString;
                    quaiboDailyProductionStore.initFormaData.productionDate =
                      getPickerDate(date);
                  }}
                  style={{ width: "100%" }}
                  defaultValue={toAntPickerDate(new Date())}
                  format={"DD-MMM-YYYY"}
                />
              </Tooltip>
            </FormItem>
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <QuaiboDailyProductionForm />
          </div>
        </div>
      </Content>
    </Layout>
  );
});

